

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MeetingMaster } from '../models/meetingmaster';
import { Department } from '../models/department';

@Injectable({
  providedIn: 'root'
})
export class MeetingMasterService {
  apiEndpoint: string="";
  baseApiUrl: any;
  apiUniqueId: string = 'Meeting/id/D32A6CC9-353B-4E23-90FB-3C410CD6FD7E';

  constructor(private httpService: HttpWrapperService, 
    private http: HttpClient,
    private configService: ConfigService) { 
      this.apiEndpoint = this.configService.getConfigValue("apiEndpoint");
      this.apiEndpoint += this.apiUniqueId;
    }
    getAllMeeting(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<any>>{ 
      return this.httpService.get(this.apiEndpoint + '/getAllMeeting?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                   
        if (result.Success && result.Success ) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }

    viewMeeting(Meeting_Id?: string): Observable<Array<MeetingMaster>> {
      return this.httpService.get(this.apiEndpoint + '/viewMeeting/' + (Meeting_Id ? Meeting_Id : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
    saveMeeting(Meeting: MeetingMaster): Observable<any> { 
      return this.httpService.post(this.apiEndpoint + '/saveMeeting/', Meeting).pipe(map((result: any) => {
        if (result.Success) { 
          return result.Data;
        } else {
          return [];
        }
      }));
    }
  
    deleteMeeting(Meeting_Id?: string): Observable<any> {
      return this.httpService.post(this.apiEndpoint + '/deleteMeeting/' + (Meeting_Id ? Meeting_Id : '00000000-0000-0000-0000-000000000000'), Meeting_Id).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
  
    checkDuplication(MeetingName?: string,Meeting_Id?: string): Observable<any> {
      return this.httpService.get(this.apiEndpoint + '/checkDuplication?MeetingName=' + (MeetingName ? MeetingName : '')+ '&Meeting_Id=' + (Meeting_Id ? Meeting_Id : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
          return result; 
      }));
    }


  
  }

